module.exports = __webpack_public_path__ + "img/12.5.COD.2f88ed74.png";